var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSecurity = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.261 20c.157 0 .418-.052.669-.198 5.64-3.123 7.592-4.491 7.592-8.094v-7.53c0-1.087-.46-1.442-1.347-1.818C14.037 1.88 10.298.543 9.159.157 8.877.063 8.554 0 8.261 0c-.303 0-.616.084-.898.157C6.225.48 2.475 1.89 1.337 2.36.449 2.726 0 3.091 0 4.178v7.53c0 3.603 1.953 4.95 7.582 8.094.25.146.512.198.68.198zm0-1.9c-.157 0-.313-.053-.595-.23-4.554-2.758-5.995-3.541-5.995-6.538V4.48c0-.334.063-.47.345-.584 1.483-.585 4.376-1.557 5.806-2.12.178-.074.314-.095.44-.095.114 0 .25.032.438.094 1.43.564 4.292 1.598 5.807 2.12.271.105.334.251.334.585v6.852c0 2.997-1.462 3.801-5.985 6.537-.292.178-.449.23-.595.23zm2.454-3.76c.69 0 1.024-.356 1.024-1.097V9.42c0-.647-.25-.992-.773-1.075v-1.16c0-1.817-1.086-3.039-2.705-3.039s-2.715 1.222-2.715 3.04v1.17c-.523.083-.763.417-.763 1.064v3.823c0 .741.324 1.096 1.024 1.096h4.908zM6.632 8.333V7.081c0-1.138.647-1.89 1.63-1.89.97 0 1.628.752 1.628 1.89v1.243l-3.258.01z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSecurity, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/_security.9b153962.svg";
export { ForwardRef as ReactComponent };